import React from 'react'

const UpdateCandidate = () => {
  return (
    <div>UpdateCandidate</div>
  )
}

export default UpdateCandidate